import {Component, Input, Output, EventEmitter} from '@angular/core'
import {DateFormatService} from "dmmp-services";

@Component({
  selector: 'dmmp-website-card-article-featured',
  templateUrl: './website-card-article-featured.component.html',
})
export class WebsiteCardArticleFeaturedComponent {
  @Input() data
  @Input() type
  @Output() page = new EventEmitter()
  @Input() defaultClass
  @Input() classArticle

  constructor(public dateFormat: DateFormatService) {
  }
}
